import "./dialog.css"
import Dialog from "./Dialog"
import DialogTrigger from "./DialogTrigger"
import DialogContent from "./DialogContent"
import DialogHeader from "./DialogHeader"
import DialogTitle from "./DialogTitle"
import DialogFooter from "./DialogFooter"
import DialogDescription from "./DialogDescription"
import DialogClose from "./DialogClose"

export type { DialogProps } from "./Dialog"
export type { DialogTriggerProps } from "./DialogTrigger"
export type { DialogContentProps } from "./DialogContent"
export type { DialogHeaderProps } from "./DialogHeader"
export type { DialogTitleProps } from "./DialogTitle"
export type { DialogFooterProps } from "./DialogFooter"
export type { DialogDescriptionProps } from "./DialogDescription"
export type { DialogCloseProps } from "./DialogClose"

export default Object.assign(Dialog, {
  Trigger: DialogTrigger,
  Content: DialogContent,
  Header: DialogHeader,
  Title: DialogTitle,
  Footer: DialogFooter,
  Description: DialogDescription,
  Close: DialogClose,
})
